import { createSelector } from "reselect";

import { AltarStore } from "shared/types";

const selectStripe = (state: AltarStore) => state.stripe;

export const getStripe = () => createSelector(selectStripe, state => state.stripe);
